/* Print any register or list the same way — a clean, branded sheet in a new
   window, so "Print" means the same thing everywhere in the cockpit. */

import { STUDIO } from "./store";

export interface PrintCol { key: string; label: string; align?: "left" | "right" | "center"; width?: string }

export function printTable(o: {
  title: string; subtitle?: string; meta?: string[];
  columns: PrintCol[]; rows: Record<string, string | number | undefined>[];
  note?: string;
}) {
  const esc = (s: unknown) => String(s ?? "").replace(/[&<>]/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[m]!));
  const head = o.columns.map((c) => `<th style="text-align:${c.align ?? "left"}${c.width ? `;width:${c.width}` : ""}">${esc(c.label)}</th>`).join("");
  const body = o.rows.map((r) => `<tr>${o.columns.map((c) => `<td style="text-align:${c.align ?? "left"}">${esc(r[c.key])}</td>`).join("")}</tr>`).join("");
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${esc(o.title)}</title>
<style>
  @page { size: A4; margin: 16mm 14mm; }
  * { box-sizing: border-box; }
  body { font: 11px/1.5 -apple-system, "Segoe UI", Helvetica, Arial, sans-serif; color: #2c2825; margin: 0; }
  header { border-bottom: 1.5px solid #8a8f98; padding-bottom: 10px; margin-bottom: 14px; }
  .studio { font: 500 15px Georgia, serif; color: #1a1714; }
  .kicker { font-size: 8px; letter-spacing: 2.2px; text-transform: uppercase; color: #6b665e; margin-top: 3px; }
  h1 { font: 500 20px Georgia, serif; color: #1a1714; margin: 12px 0 4px; }
  .sub { color: #6b665e; font-size: 11px; }
  .meta { color: #6b665e; font-size: 10px; margin-top: 6px; }
  table { width: 100%; border-collapse: collapse; margin-top: 12px; }
  th { font-size: 8px; letter-spacing: .7px; text-transform: uppercase; color: #6b665e; font-weight: 600; border-bottom: 1px solid #8a8f98; padding: 6px 6px 6px 0; }
  td { padding: 6px 6px 6px 0; border-bottom: .5px solid #d8d1c3; vertical-align: top; }
  tr { break-inside: avoid; }
  footer { margin-top: 16px; padding-top: 8px; border-top: .5px solid #d8d1c3; color: #9a948a; font-size: 9px; display: flex; justify-content: space-between; }
  .note { margin-top: 10px; font-size: 9.5px; color: #6b665e; font-style: italic; }
</style></head><body>
<header>
  <div class="studio">${esc(STUDIO.name)}</div><div class="kicker">${esc(STUDIO.tagline || "Architecture · Interiors")}</div>
  <h1>${esc(o.title)}</h1>
  ${o.subtitle ? `<div class="sub">${esc(o.subtitle)}</div>` : ""}
  ${o.meta?.length ? `<div class="meta">${o.meta.map(esc).join(" &nbsp;·&nbsp; ")}</div>` : ""}
</header>
<table><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table>
${o.note ? `<div class="note">${esc(o.note)}</div>` : ""}
<footer><span>${esc(STUDIO.name)} · ${esc(STUDIO.domain)}</span><span>${o.rows.length} row${o.rows.length === 1 ? "" : "s"} · printed ${new Date().toLocaleDateString()}</span></footer>
<script>window.onload=()=>{window.print()}</script>
</body></html>`;
  const w = window.open("", "_blank", "noopener,width=980,height=760");
  if (!w) { alert("Allow pop-ups to print this view."); return; }
  w.document.write(html); w.document.close();
}
